var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactsActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0_112_613)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_112_613",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_112_613",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_112_613",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC0klEQVR4nO2dz4tNcRyGT8aPiZXuRigxOzaSQlHDaiRbCwspZociO2XmL1AszIKVtSwofwJ27MSU7LCQdC0GNY9O3WIyzty55/N5nb7zPuu53ed97u3O3HPOnVtVxhhjjDGdhLXHN+AFcAXY5NAaXgE7HVoXO/+ZLRrTdS47tIbnDq2h79AiHFqEQ4twaBEOLcKhRTi0CIcW4dAiHFqEQ4twaBElhv4M3AVOAruBLcBm4ABwC/jxH5yKC30f6K3gcxxYEHsVFXpmFU6ngHv14UuVXCmhn4zotguYVwjGl/17TDY/62At/A4Ci9mSsVWXH5LN4wDHp9mSMTWbR2QzHeA4nS0ZU7N5RDb7AxwPZ0vG1GwekU0vwLH+pZhKTM3mEdlsCHAcz5aMqdk8IputAY69bMmYms0jsjkS4HgoWzKmZvOIbG4GON7Iloyp2Twim7kAx7lsyZiazSOy2RPgOJEtGVOzeUQ2EwGODj0E5wIcz5NMTM3mEdm8qQ/wt/CrTw68zZaMrbr8EAWvW/jVD1Q6sVWXH6Ji7whu+1RyOXWXjlHxcAS3Ryq5nLpLxyg5uwqvM0qx0kL3gaNDOB0bfB5QRmmha2aHcJpFjEOLcGgRpYVeBCaHcJpUnPkuNfT31XxCtf7ZwW0klBD6I3BnlINLg4NJt4EP2ZI5dZeOyeAL8AA4HXTOcF39Z+Eg+qcM4ZiazSMimQcuZv63AGAjcCH6UrEs3z/FI1gArgJj6cK/vccG9xly5alCuC0LwFS66L/9pyJiK0Tbci1dcuUN10sP/R5Yny453MvIu5JDz1Qdoe27SYVgGyarjgCcKDn0tqojANtLDj1edYS2F0IqBA0OLcOhRTi0CIcW4dAiHFqEQ4twaBEOLcKhRTi0CIcW4dAiHFqEQ2v46tAa/GUKIi45dD4v68vMHDo/8o70yGs0dB94Vr9cSJ7JxhhjjDFVG34B9eGRRuLiJWUAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsActive);
export default __webpack_public_path__ + "static/media/Contacts-active.34f3c491392197eeb575530860d295c5.svg";
export { ForwardRef as ReactComponent };